export const NavigationTestIds = {
  // Contenedor principal
  navigationContainer: 'navigation-container',

  // Links de navegación
  myReferralsLink: 'navigation-my-referrals-link',
  marketplaceLink: 'navigation-marketplace-link',
  analyticsLink: 'navigation-analytics-link',
  myNetworkLink: 'navigation-my-network-link',

  // My Network
  memberDirectoryLink: 'navigation-member-directory-link',
  waterfallLink: 'navigation-waterfall-link',
  myReferralNetworkLink: 'navigation-my-referral-network-link',

  // Contenedores
  desktopNavContainer: 'navigation-desktop-container',
  mobileNavContainer: 'navigation-mobile-container',

  // Menú de usuario
  userMenuButton: 'navigation-user-menu-button',
  userMenuDropdown: 'navigation-user-menu-dropdown',
  logoutLink: 'navigation-logout-link',

  // Logo
  logo: 'navigation-logo',
}

export default NavigationTestIds
